import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyles = styled.div`
  padding-top: 10rem;
  background-color: var(--deep-dark);
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright{
    background-color: var(--dark-bg)
    text-align: left;
    padding:  1rem 0;
    margin-top: 5rem;
    .para{
        margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px){
      .container{
          flex-direction: column;
          gap: 0rem;
          & > div{
              margin-top: 5rem;
          }
      }
      .footer__col1 .para{
          max-width: 100%;
      }
      .copyright{
          .container{
              div{
                  margin-top: 0;
              }
          }
      }
  }
`;

export default function Footer() {
  return (
    <FooterStyles>
      <div className="container">
        <div className="footer__col1">
          <h3 className="footer__col1__title">Naveen Kumar</h3>
          <PText>
            A backend web developer from Kurnool, India. I love to code,
            passionate to learn new skills. I try to make things automate/write
            scripts that flashes in my head.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                title: 'About',
                path: '/about',
                type: 'Link',
              },
              {
                title: 'Projects',
                path: '/projects',
                type: 'Link',
              },
              {
                title: 'Contact',
                path: '/contact',
                type: 'Link',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: 'sayhai2naveenkumar@gmail.com',
                path: 'mailto:sayhai2naveenkumar@gmail.com',
              },
              {
                title: 'Kurnool, India',
                path:
                  'https://www.google.com/maps/place/Kurnool,+Andhra+Pradesh/@15.8118414,78.0047825,13z/data=!3m1!4b1!4m5!3m4!1s0x3bb5ddf506b7c6c9:0x19a7ac74f858d6f2!8m2!3d15.8281257!4d78.0372792',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Social Links"
            links={[
              {
                title: 'LinkedIn',
                path: 'https://www.linkedin.com/in/naveen0003',
              },
              {
                title: 'Instagram',
                path: 'https://www.instagram.com/navinn_kumar/',
              },
              {
                title: 'Twitter',
                path: 'https://twitter.com/iM_Nvnkumar',
              },
              {
                title: 'Github',
                path: 'https://github.com/Spidey03',
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>@ 2021 - Naveen Kumar | Designed by Spidey03</PText>
        </div>
      </div>
    </FooterStyles>
  );
}
